import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';

import { ApiService, GlobalVar } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  channel;

  constructor(
    public globalvar: GlobalVar,
    public apiService: ApiService,
  ) {
    var pusher = new Pusher(this.globalvar._pusherKey, {
      cluster: this.globalvar._pusherCluster,
      // encrypted: true,
      authEndpoint: `${this.globalvar._apiUrl}/broadcasting/auth`,
      auth: {
        headers: {
          "Authorization": `Bearer ${this.globalvar._token}`
        }
      }
    });
    this.channel = pusher.subscribe(`private-chat.${this.globalvar._user.id}`);
  }

  public init() {
    return this.channel;
  }

  post(body) {
    return this.apiService.post(`${this.globalvar._postPusher}/${this.globalvar._user.id}`, body);
  }

  get() {
    return this.apiService.get(`${this.globalvar._getPusher}/${this.globalvar._user.id}`);
  }

  deleteMessage(body) {
    return this.apiService.post(`${this.globalvar._deletePusher}/${body.message?.id}`, body);
  }
}
